export const formFields = (ctx) => {
  return [
    {
      name: '业务类别',
      prop: 'businessCategory',
      type: 'select',
      options: ctx.dictListMap?.businessCategory || [],
      disabled: true,
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'settlementParkWarehouseContract',
      isMultiple: true,
      changeMethod: 'changeMethod',
      currentValue: ctx.query?.contractNo,
      disabled: ctx.status == 'edit',
    },
    {
      name: '客户名称',
      prop: 'customerNo',
      type: 'select',
      options: ctx.customerList,
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '项目编号',
      prop: 'projectInitiationNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
      disabled: true,
    },
  ];
};

export const tableRules = () => {
  return {
    expenseType: [{ required: true, message: '必填项' }],
    accountPeriod: [{ required: true, message: '必填项' }],
    originalPrice: [{ required: true, message: '必填项' }],
    statementQuantity: [{ required: true, message: '必填项' }],
    originalAmount: [{ required: true, message: '必填项' }],
    domesticAmount: [{ required: true, message: '必填项' }],
    periodDateFrom: [{ required: true, message: '必填项' }],
    periodDateUntil: [{ required: true, message: '必填项' }],
  };
};

export const formRules = () => {
  return {
    contractNo: [{ required: true, message: '必填项' }],
  };
};
